import { withStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import InfinityUsersList from '../../../components/Common/Users/InfinityUsersList';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js';


// Apply some reset
const styles = theme => ({
    root: {
        width: '100%',
        height: '80%',
        flexGrow: 1,
    },
    title: {
        textAlign: 'center'
    }
});

class SelectSuperior extends Component {



    state = {
        checked: []
    }

    findChildren(user, offspring = new Set()) {
        const { users } = this.props

        const children = users.filter(r => r.superiorId == user.id)
        children.forEach(child => {
            if (!offspring.has(child.id)) {
                offspring.add(child.id)
                this.findChildren(child, offspring)
            }
        })

        return offspring
    }

    initFilter() {
        const { userId, users } = this.props

        const user = users.find(u => u.id === userId)
        let childrenIds = []
        if (user) {


            const children = this.findChildren(user)

            childrenIds = Array.from(children)
        }

        childrenIds.push(userId)

        this.setState({
            filter: childrenIds
        })
    }

    componentWillMount() {
        this.initFilter()
    }


    componentWillReceiveProps(nextProps) {
        const { superiorId } = nextProps;
        const checked = [];

        if (superiorId != this.props.superiorId) {
            const checked = [superiorId];
            this.setState({ checked })
        }
    }

    selectUser = (checked) => {
        const { selectUser, handleClose } = this.props
        selectUser(checked[0])
        handleClose()

    }


    render() {
        const { classes, open, t, handleClose, title } = this.props;

        return <Dialog
            classes={{ paper: classes.root }}
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title">
            <DialogTitle className={classes.title}>
                Supervisor
            </DialogTitle>
            <DialogContent>
                <InfinityUsersList
                    onChange={this.selectUser}
                    multiSelect={false}
                    checked={this.state.checked}
                    numRowInView={9}
                />
            </DialogContent>
            <DialogActions>                
            </DialogActions>
        </Dialog>
    }
}

const mapStateToProps = (state) => ({
    users: state.globalData.users,
})



export default compose(withStyles(styles),
    withErrorCatcher(),
    withTranslation('selectSuperior'),
    connect(mapStateToProps))(SelectSuperior);